import React from "react";
//
import { Outlet } from "react-router";

const BillingRecheck = () => {
  return <Outlet />;
};

export default BillingRecheck;
